import script from "./sidebar-file-preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-file-preview.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__